// src/pages/History/EarlyModern/EuropeanMaritimeEmpires.jsx
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Early_Modern_Period_-_European_Maritime_Empires.png';

function HistoryPageEuropeanMaritimeEmpires() {
  return (
    <TopicPage
      topicKey="European Maritime Empires"
      title="History: European Maritime Empires"
      backgroundImage={bg}
      startRoute="/History-European-Maritime-Empires-Go"
      scrollLabels={[
        "Portugal and Spain's Naval Innovations",
        "Colonial Expansion and Trade Routes",
        "Rivalry and Empire Building",
      ]}
      backRoute="/history-early-modern"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageEuropeanMaritimeEmpires;
